"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGetProductsParams = void 0;
var debug_1 = require("./debug");
var md5 = require("blueimp-md5");
var ConfigKey;
(function (ConfigKey) {
    ConfigKey["Remote"] = "remote";
    ConfigKey["Client"] = "client";
    ConfigKey["AppKey"] = "app_key";
    ConfigKey["AppSecret"] = "app_secret";
})(ConfigKey || (ConfigKey = {}));
var devConfig = (_a = {},
    _a["" + ConfigKey.Remote] = "http://dev-api3.tbox.me:8080",
    _a["" + ConfigKey.Client] = {
        web: "vela_pc",
        mweb: "vela"
    },
    _a["" + ConfigKey.AppKey] = {
        web: "FIQ79MXR",
        mweb: "V06GF3A2"
    },
    _a["" + ConfigKey.AppSecret] = {
        web: "606caa95b19bc709syqx9cpl72kmmnzy",
        mweb: "f838905ddd031399ffdm8n3mymrrzomk"
    },
    _a);
var prodConfig = (_b = {},
    _b["" + ConfigKey.Remote] = "https://api.lightinthebox.com",
    _b["" + ConfigKey.Client] = {
        web: "vela_pc",
        mweb: "vela"
    },
    _b["" + ConfigKey.AppKey] = {
        web: "FIQ79MXR",
        mweb: "V06GF3A2"
    },
    _b["" + ConfigKey.AppSecret] = {
        web: "606caa95b19bc709syqx9cpl72kmmnzy",
        mweb: "f838905ddd031399ffdm8n3mymrrzomk"
    },
    _b);
exports.getGetProductsParams = function (param) {
    var _a, _b;
    var _c = param.platform, platform = _c === void 0 ? "mweb" : _c, sid = param.sid, sessionkey = param.sessionkey;
    var config = debug_1.isUAT() ? devConfig : prodConfig;
    var sign = ConfigKey.AppKey + config[ConfigKey.AppKey] + ConfigKey.AppSecret + config[ConfigKey.AppSecret];
    var md5sign = md5(sign);
    return {
        app_key: ((_a = config === null || config === void 0 ? void 0 : config[ConfigKey.AppKey]) === null || _a === void 0 ? void 0 : _a[platform]) || "",
        app_secret: ((_b = config === null || config === void 0 ? void 0 : config[ConfigKey.AppSecret]) === null || _b === void 0 ? void 0 : _b[platform]) || "",
        sessionkey: sessionkey,
        sid: sid,
        sign: md5sign || ""
    };
};
